/**
 * Reusable list footer: page + optional rows-per-page (client-side tables).
 */
export function TablePagination({
  page,
  totalPages,
  onPageChange,
  totalItems,
  pageSize,
  onPageSizeChange,
  sizeOptions = [5, 10, 15, 20, 25, 30, 40, 50, 100, 200, 500],
}) {
  const ALL_VALUE = "all";
  const hasAllOption = sizeOptions.some(
    (option) => String(option).toLowerCase() === ALL_VALUE,
  );
  const optionsWithAll = hasAllOption ? sizeOptions : [...sizeOptions, ALL_VALUE];
  const isAllSelected = Number(pageSize) >= Number.MAX_SAFE_INTEGER / 2;
  const pageSizeSelectValue =
    totalItems != null && (isAllSelected || Number(pageSize) >= Number(totalItems || 0))
      ? ALL_VALUE
      : String(pageSize);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4 py-3 border-t border-stone-200 bg-stone-50/50 text-sm text-stone-600">
      <p>
        {totalItems != null
          ? `Showing ${Math.min(
              totalItems,
              (page - 1) * pageSize + 1,
            )}–${Math.min(
              totalItems,
              page * pageSize,
            )} of ${totalItems}`
          : `Page ${page} of ${totalPages}`}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        {onPageSizeChange && (
          <label className="inline-flex items-center gap-1.5 text-xs text-stone-600">
            Rows
            <select
              value={pageSizeSelectValue}
              onChange={(e) => {
                if (e.target.value === ALL_VALUE) {
                  onPageSizeChange(Number.MAX_SAFE_INTEGER);
                  return;
                }
                onPageSizeChange(Number(e.target.value));
              }}
              className="px-2 py-1 border border-stone-300 rounded-lg text-stone-800"
            >
              {optionsWithAll.map((n) => (
                <option key={String(n)} value={String(n)}>
                  {String(n).toLowerCase() === ALL_VALUE ? "All" : n}
                </option>
              ))}
            </select>
          </label>
        )}
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => onPageChange((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
            className="px-3 py-1.5 rounded-lg border border-stone-300 hover:bg-stone-100 disabled:opacity-50"
          >
            Previous
          </button>
          <button
            type="button"
            onClick={() => onPageChange((p) => Math.min(totalPages, p + 1))}
            disabled={page >= totalPages}
            className="px-3 py-1.5 rounded-lg border border-stone-300 hover:bg-stone-100 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
